
import React from "react";
import "./radio.scss";
import { RadioGroup } from "@progress/kendo-react-inputs";

// interface to declare all our prop types

export type Props = {
  data?: { label: string, value: number }[];
  checked?: number;
  handleChange?: any;
  defaultChecked?: boolean;
  disabled?: boolean;
  layout: any;
  name?: string;
  defaultValue?: any;

}

const RadioDefault: React.FC<Props> = ({
  data = [] ,
  checked = '',
  handleChange,
  name,
  defaultValue,
  layout = "horizontal",
  ...rest
}) => {
  return (
    <div className="radio">
      <RadioGroup
        data={data}
        value={checked}
        onChange={handleChange}
        layout={layout}
        name={name}
        defaultValue={checked}
        
      />
    </div>
  );
};

export default RadioDefault;


